module.exports = __webpack_public_path__ + "static/media/imagem36.ea2ca64f.jpeg";